import Phaser from 'phaser';
import { SaveManager } from '../game/SaveManager';
import { Ads } from '../game/ads';

/**
 * Boot: load the persisted save and request a landscape orientation lock, then hand
 * off to Preload. The CSS rotate-hint in index.html covers devices that ignore the lock.
 */
export class Boot extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  preload(): void {
    // Load the brand logo up front so the Preload screen can show it (instead of plain text).
    this.load.image('logo', 'assets/ui/logo.png');
  }

  async create(): Promise<void> {
    this.lockLandscape();
    // Init the ad provider BEFORE loading the save, so the CrazyGames Data Module (if that's the
    // build) is ready and becomes the save store. No-op + instant for GameMonetize / off-portal.
    await Ads.init();
    await SaveManager.instance.load();
    // Set up optional Google cloud-save in the background (returning players get auto-signed in
    // and their progress synced); never blocks the boot.
    void SaveManager.instance.initCloud();
    this.scene.start('Preload');
  }

  private lockLandscape(): void {
    const orientation = screen.orientation as (ScreenOrientation & { lock?: (o: string) => Promise<void> }) | undefined;
    // Only works in fullscreen/installed PWA contexts; fails silently otherwise.
    orientation?.lock?.('landscape').catch(() => {
      /* not permitted outside fullscreen — rotate-hint handles it */
    });
  }
}
